// extracted by mini-css-extract-plugin
module.exports = {"Hamburger":"Hamburger-module__Hamburger___1mNri"};